import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import {LockoutService} from 'auth-commons';
import {ECMemberAccessType} from 'smag-commons/cfg/hierarchy';
import {SmagApiService} from './api/smag-api.service';

@Injectable()
export class AdvancedUserGuard implements CanActivate, CanActivateChild {
    constructor(private readonly router: Router,
                private readonly lockout: LockoutService,
                private readonly apiService: SmagApiService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean|UrlTree> {
        return this.apiService.getSubjectInfo()
            .toPromise()
            .then((subject) => {
                if (!subject || subject.subject.access_type !== ECMemberAccessType.ADVANCED) {
                    return true;
                } else {
                    return this.gotoCommunityDashboard(subject.subject.network_id);
                }
            }).catch((err) => {
                console.error(err);
                this.exit();
                return false;
            });
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return this.canActivate(route, state);
    }

    private exit() {
        this.lockout.lockout();
    }

    private gotoCommunityDashboard(communityId: string): UrlTree {
        return this.router.createUrlTree(['/c', 'ec', 'dashboard'],
            {
                queryParams: {
                    id: communityId
                },
                queryParamsHandling: 'merge'
            });
    }
}
